import { Card, CardContent } from "@/components/ui/card";

export const SkeletonLoader = () => (
  <div className="space-y-6 animate-pulse">
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {[...Array(4)].map((_, i) => (
        <Card key={i} className="bg-gray-200" />
      ))}
    </div>
    <div className="grid md:grid-cols-2 gap-6">
      <Card className="bg-gray-200 h-64" />
      <Card className="bg-gray-200 h-64" />
    </div>
    <Card className="bg-gray-200 h-96" />
  </div>
);

export const AnalyticsEmptyState = ({ type = "nodata" }) => {
  const states = {
    nodata: {
      title: "Sin datos aún",
      description:
        "Los datos comenzarán a aparecer cuando haya actividad en el chatbot.",
    },
    error: {
      title: "Error al cargar datos",
      description: "Intenta recargar la página.",
    },
    no_hourly: {
      title: "Datos horarios no disponibles",
      description: "No hay suficientes datos para mostrar distribución horaria.",
    },
  };

  const state = states[type] || states.nodata;

  return (
    <Card className="bg-card border-border/50">
      <CardContent className="flex flex-col items-center justify-center py-16 text-center">
        <p className="text-3xl mb-3">📊</p>
        <p className="text-lg font-medium">{state.title}</p>
        <p className="text-sm text-muted-foreground">{state.description}</p>
      </CardContent>
    </Card>
  );
};
